function addBusinessDays(date, days) {
  const result = new Date(date);
  let remaining = Math.max(0, Number(days) || 0);

  while (remaining > 0) {
    result.setDate(result.getDate() + 1);
    const weekday = result.getDay();
    if (weekday !== 0 && weekday !== 6) remaining -= 1;
  }

  return result;
}

function addCalendarDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + Math.max(0, Number(days) || 0));
  return result;
}

function formatDate(date, includeYear = false) {
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    ...(includeYear ? { year: 'numeric' } : {}),
  });
}

function formatRange(start, end) {
  const includeYear = start.getFullYear() !== end.getFullYear();
  return `${formatDate(start, includeYear)} - ${formatDate(end, includeYear)}`;
}

function renderEstimate(root) {
  const target = root.querySelector('[data-elx-delivery-date]');
  if (!target) return;

  const today = new Date();
  const processingMin = Number(root.dataset.elxProcessingDaysMin) || 1;
  const processingMax = Number(root.dataset.elxProcessingDaysMax) || processingMin;
  const transitMin = Number(root.dataset.elxTransitDaysMin) || 3;
  const transitMax = Number(root.dataset.elxTransitDaysMax) || transitMin;
  const earliest = addCalendarDays(addBusinessDays(today, processingMin), transitMin);
  const latest = addCalendarDays(addBusinessDays(today, processingMax), transitMax);

  target.textContent = formatRange(earliest, latest);
}

function renderAllEstimates(scope = document) {
  scope.querySelectorAll('[data-elx-delivery-estimate]').forEach(renderEstimate);
}

renderAllEstimates();
document.addEventListener('DOMContentLoaded', () => renderAllEstimates());
document.addEventListener('shopify:section:load', (event) => renderAllEstimates(event.target));

// Recalculate after midnight if a visitor leaves the page open.
window.setInterval(() => renderAllEstimates(), 5 * 60 * 1000);
